<template>
  <q-dialog
    v-model="dialog"
    style="max-width: 500px"
    persistent
    class="custom-font text-uppercase"
  >
    <q-card class="full-width pragma-black text-white">
      <q-form @submit.prevent="autorizar()">
        <q-card-section class="q-pa-none text-white">
          <q-toolbar
            class="bg-pragma"
          >
            <span class="text-bold">Autorizar Solicitud</span>
            <q-space></q-space>
            <q-btn
              icon="clear"
              flat
              @click="closeDialog()"
            ></q-btn>
          </q-toolbar>
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-xs-12">
              <q-checkbox
                v-model="observar"
                label="¿Desea realizar alguna observación?"
                dark
              ></q-checkbox>
            </div>
            <div class="col-xs-12" v-if="observar">
              <q-input
                v-model="observacion"
                type="textarea"
                label="Describa sus observaciones"
                class="tu"
                autogrow
                dense
                outlined
                label-color="grey"
                dark
                :rules="[v => !!v || 'Requerido']"
              ></q-input>
            </div>
          </div>
        </q-card-section>
        <q-card-actions>
          <div class="row full-width">
            <div class="col-xs-6 q-pa-sm">
              <q-btn
                label="Cancelar"
                color="negative"
                icon="clear"
                class="full-width"
                @click="closeDialog()"
              ></q-btn>
            </div>
            <div class="col-xs-6 q-pa-sm">
              <q-btn
                type="submit"
                label="Autorizar"
                color="positive"
                icon="check"
                class="full-width"
                :loading="loading"
              ></q-btn>
            </div>
          </div>
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import {inject, ref} from 'vue'
import axios from 'axios'
import { useQuasar } from 'quasar'
import util from '../../../../plugins/util'

export default {
  setup () {
    // Variables reactivas y no reactivas
    const bus = inject('bus')
    const $q = useQuasar()
    
    const dialog = ref(false)
    const observar = ref(false)
    const observacion = ref('')
    const solicitud_id = ref(null)
    const loading = ref(false)

    // Métodos y funciones
    const autorizar = async () => {
      try {
        loading.value = true
        let platform
        if ($q.platform.is.platform === 'android') {
          platform = 'A'
        } else if ($q.platform.is.platform === 'iphone') {
          platform = 'I'
        } else {
          platform = 'W'
        }
        if (observar.value) {
          await axios.get(`solicitud-autorizacion/${solicitud_id.value}/${observacion.value}/${platform}`)
        } else {
          await axios.get(`solicitud-autorizacion/${solicitud_id.value}/SO/${platform}`)
        }
        $q.notify({
          message: 'Solicitud autorizada',
          color: 'positive'
        })

        // Reseteo de variables
        observacion.value = ''
        solicitud_id.value = null
        loading.value = false
        observar.value = false
        bus.emit('closeDialogEventoAutorizar')
        closeDialog()
      } catch (error) {
        loading.value = false
        return console.log(error)
      }
    }

    const closeDialog = () => {
      observar.value = false
      observacion.value = ''
      solicitud_id.value = null
      loading.value = false
      dialog.value = false
    }

    // Creación del componente
    bus.on('openDialogAutorizarSolicitud', (item) => {
      util.verifyBanned('authorize')
      solicitud_id.value = item
      dialog.value = true
    })

    // Retorno de variables al template
    return {
      dialog,
      observar,
      observacion,
      autorizar,
      loading,
      closeDialog
    }
  }
}
</script>

<style>

</style>